module.exports = __webpack_public_path__ + "assets/img/EKSElement-start-path.77a4547c.svg";